import { render, staticRenderFns } from "./partner-promote.vue?vue&type=template&id=b9ccbf4c"
import script from "./partner-promote.vue?vue&type=script&lang=js"
export * from "./partner-promote.vue?vue&type=script&lang=js"
import style0 from "./partner-promote.vue?vue&type=style&index=0&id=b9ccbf4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports